<template>
  <gg-card class="fill-height">
    <v-skeleton-loader :loading="loading" type="article">
      <gg-card-header>
        Affiliate Information
      </gg-card-header>
      <gg-card-text v-if="profile">
        <v-row>
          <v-col cols="12">
            <div>
              Affiliate Username: <b ref="username">{{ profile.username }}</b>
              <gg-btn icon class="ml-3" @click="copyToClipboard('username')">
                <v-icon small>mdi-content-copy</v-icon>
              </gg-btn>
            </div>
            <div>
              Your Affiliate Tracking URL: <b ref="url">https://www.greengeeks.com/track/{{ profile.username }}</b>
              <gg-btn icon class="ml-3" @click="copyToClipboard('url')">
                <v-icon small>mdi-content-copy</v-icon>
              </gg-btn>
            </div>
          </v-col>
        </v-row>
      </gg-card-text>
    </v-skeleton-loader>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AccountInformation',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: mapGetters({
    profile: 'affiliates/profile',
    linkAccountFailed: 'affiliates/linkAccountFailed'
  }),
  methods: {
    ...mapActions({
      reportSuccess: 'reportSuccess'
    }),
    copyToClipboard (text) {
      const toCopy = this.$refs[text]
      navigator.clipboard.writeText(toCopy.innerHTML)

      this.reportSuccess('Copied')
    }
  }
}
</script>

<style scoped>

</style>
